import { IconXMark } from '@/components/icons/IconXMark';
import type { VehicleActiveFilter } from './vehicleActiveFilters';

type VehicleActiveFiltersProps = {
    chips: VehicleActiveFilter[];
    onRemove: (chip: VehicleActiveFilter) => void;
    onReset: () => void;
};

/** Below md the filters sit in the drawer, so the active ones show above the results. */
export function VehicleActiveFilters({ chips, onRemove, onReset }: VehicleActiveFiltersProps) {
    if (!chips.length) return null;

    return (
        <div className="vehicle-active-filters md:hidden">
            <ul className="vehicle-active-filters__list">
                {chips.map((chip) => (
                    <li key={chip.id} className="vehicle-active-filter label-xs">
                        {chip.label}
                        <button
                            type="button"
                            className="vehicle-active-filter__remove"
                            aria-label={`${chip.label} entfernen`}
                            onClick={() => onRemove(chip)}
                        >
                            <IconXMark width={14} height={14} aria-hidden="true" />
                        </button>
                    </li>
                ))}
            </ul>

            <button type="button" className="vehicle-active-filters__reset label-xs" onClick={onReset}>
                Alle zurücksetzen
            </button>
        </div>
    );
}
